import {z} from 'zod'

export type TimeEntryId = `time-${string}`
export const TimeEntryId = z.string().startsWith('time-') as z.ZodType<TimeEntryId>
